// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Color definitions for the app
 */

.ManageTags {
  height: 100%;
  font-size: 12px;
  overflow: hidden;
}
.ManageTags .manage-header {
  display: flex;
  align-items: center;
  height: 105px;
  padding: 0 30px;
}
.ManageTags .manage-header .header-info .header-title {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  font-size: 18px;
  font-weight: 900;
}
.ManageTags .manage-header .header-info .header-title .undo-redo {
  margin-left: 20px;
  user-select: none;
}
.ManageTags .manage-header .header-info .header-subtitle {
  font-size: 14px;
}
.ManageTags .manage-header .header-buttons {
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.ManageTags .manage-tabs {
  display: flex;
  height: 30px;
  padding: 0 30px;
  user-select: none;
}
.ManageTags .manage-tabs .tab {
  cursor: pointer;
  position: relative;
  margin-right: 15px;
  text-transform: uppercase;
}
.ManageTags .manage-tabs .tab .active-bar {
  display: none;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: #333F48;
}
.ManageTags .manage-tabs .tab.active {
  font-weight: 900;
}
.ManageTags .manage-tabs .tab.active .active-bar {
  display: block;
}
.ManageTags .manage-tag-list-container {
  height: calc(100% - 207px);
}
.ManageTags .manage-tag-list-container .tag-loader {
  position: absolute;
  top: calc(50% - 37.5px);
  left: calc(50% - 37.5px);
  transform: translate(-50%, -50%);
}
.ManageTags .manage-tag-list-container .manage-tag-list {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 24px;
  margin-bottom: 24px;
}
.ManageTags .manage-tag-list-container .add-tags-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  width: 300px;
  height: 105px;
  padding-top: 20px;
  padding-bottom: 20px;
}
.ManageTags .manage-tag-list-container .add-tags-container .add-tag-error {
  position: relative;
  display: block;
  margin-top: 16px;
  line-height: 16px;
  color: #CF0838;
}
.ManageTags .manage-tag-list-container .add-tags-container .add-tag-error span {
  font-weight: bold;
}
.ManageTags .manage-tag-list-container .add-tags-container .label-add-tag {
  display: block;
  margin-bottom: 5px;
  font-size: 12px;
  color: #959AAD;
  text-transform: uppercase;
}
.ManageTags .manage-tag-list-container .add-tags-container .add-tag-input-container {
  position: relative;
}
.ManageTags .manage-tag-list-container .add-tags-container .add-tag-input-container .input-add-tag {
  width: 100%;
  height: 40px;
  margin: 0 auto;
  padding-left: 10px;
  padding-right: 70px;
  font-size: 18px;
  box-sizing: border-box;
  border: 1px solid #E1E1E9;
  border-radius: 4px;
}
.ManageTags .manage-tag-list-container .add-tags-container .add-tag-input-container .input-add-tag:focus {
  outline: none;
  border: 1px solid #333F48;
}
.ManageTags .manage-tag-list-container .add-tags-container .add-tag-input-container .icon-delete-input {
  position: absolute;
  top: 0;
  right: 30px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 10px;
}
.ManageTags .manage-tag-list-container .add-tags-container .add-tag-input-container .icon-add-tag {
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 12px;
}
.ManageTags .manage-tag-list-container .empty-tags {
  margin-top: 20px;
  font-size: 18px;
  color: #959AAD;
  text-align: center;
}
.ManageTags .manage-tag-list-container .empty-tags .empty-add-tags {
  margin-top: 5px;
}`, "",{"version":3,"sources":["webpack://./src/vibeguide/src/sass/color.scss","webpack://./src/vibeguide/src/components/Tags/ManageTags.scss"],"names":[],"mappings":"AAAA;;EAAA;;ACEA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;AAwFF;AAtFE;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AAwFJ;AApFM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAsFR;AApFQ;EACE,iBAAA;EACA,iBAAA;AAsFV;AAlFM;EACE,eAAA;AAoFR;AAhFI;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,QAAA;AAkFN;AA9EE;EACE,aAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAgFJ;AA9EI;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AAgFN;AA9EM;EACE,aAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,mBDvDE;ACuIV;AA7EM;EACE,gBAAA;AA+ER;AA7EQ;EACE,cAAA;AA+EV;AAzEE;EAEE,0BAAA;AA0EJ;AAxEI;EACE,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,gCAAA;AA0EN;AAvEI;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,mBAAA;AAyEN;AAtEI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;AAwEN;AAtEM;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,cD1FA;ACkKR;AAtEQ;EACE,iBAAA;AAwEV;AApEM;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,cD3GE;EC4GF,yBAAA;AAsER;AAnEM;EACE,kBAAA;AAqER;AAnEQ;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;AAqEV;AAnEU;EACE,aAAA;EACA,yBAAA;AAqEZ;AAjEQ;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;AAmEV;AAhEQ;EACE,eAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;AAkEV;AA7DI;EACE,gBAAA;EACA,eAAA;EACA,cD/JI;ECgKJ,kBAAA;AA+DN;AA7DM;EACE,eAAA;AA+DR","sourcesContent":["/**\n * Color definitions for the app\n */\n\n// Theme Colors\n$primary: #333F48;\n$secondary: #222732;\n$yellow: #FECF0C;\n$red: #E02D4F;\n$teal: #23CCC3;\n$orange: #F66733;\n$lightGray: #F6F6F6;\n$whiteSmoke: #E1E1E9;\n$manatee: #959AAD;\n$obsidian: #383838;\n\n// Status Colors\n$success: #00A474;\n$warning: #FFC107;\n$error: #CF0838;\n\n// Other Colors\n$white: #FFFFFF;\n$black: #000000;\n$gray: #757575;\n$darkGray: #A4A7B7;\n$mediumGray: #E0E0E0;\n$lighterGray: #E3E7F4;\n$lightSlateGray: #8A8FA3;\n$carrot: #FF892E;\n$lightSmoke: #F5F4F5;\n$graphBlue: #1570EF;\n$lightOrchid: #7F56D9;\n$rainboots: #3361E1;\n$royalBlue: #4085DE;\n$sushi: #95C653;\n\n// Component Colors\n$primaryButtonBackground: $yellow;\n$primaryButtonText: $primary;\n$secondaryButtonBackground: $primary;\n$secondaryButtonText: $white;\n$navigationText: #95A3AD;\n$scheduleMusic: #FCC7B3;\n$scheduleMessageBlock: $teal;\n$scheduleInterrupt: #1997A3;\n$scheduleLoop: $primary;\n\n// Variants: Theme Colors\n$primary16: rgba($primary, 0.16);\n$primary40: rgba($primary, 0.4);\n$primary50: rgba($primary, 0.5);\n$primary60: rgba($primary, 0.6);\n$secondary25: rgba($secondary, 0.25);\n$secondary50: rgba($secondary, 0.5);\n$secondary75: rgba($secondary, 0.75);\n$yellow16: rgba($yellow, 16%);\n$yellow25: rgba($yellow, 25%);\n$yellow75: rgba($yellow, 75%);\n$orange16: rgba($orange, 0.16);\n$orange32: rgba($orange, 0.32);\n$orange50: rgba($orange, 0.5);\n$orange75: rgba($orange, 0.75);\n$manatee16: rgba($manatee, 0.16);\n$manatee50: rgba($manatee, 0.5);\n\n// Variants: Status Colors\n$success10: rgba($success, 0.08);\n$success16: rgba($success, 0.16);\n$success75: rgba($success, 0.75);\n$warning50: rgba($warning, 0.5);\n$error10: rgba($error, 0.1);\n$error16: rgba($error, 0.16);\n$error20: rgba($error, 0.2);\n$error50: rgba($error, 0.5);\n$error75: rgba($error, 0.75);\n$error85: rgba($error, 0.85);\n\n// Variants: Other Colors\n$gray50: #F9FAFB;\n$gray200: #EAECF0;\n$gray300: #D0D5DD;\n$gray400: #98A2B3;\n$gray500: #667085;\n$gray700: #344054;\n$gray900: #101828;\n$carrot16: rgba($carrot, 0.16);\n$rainboots16: rgba($rainboots, 0.16);\n$royalBlue16: rgba($royalBlue, 0.16);\n\n// Box colors (for color picker)\n$boxRed: $red;\n$boxPink: #F57A7A;\n$boxOrange: $orange;\n$boxYellow: $yellow;\n$boxGreen: #95C653;\n$boxDarkGreen: #00A474;\n$boxBlue: #33ACE1;\n$boxDarkBlue: #3361E1;\n$boxPurple: #6D6DB5;\n$boxPurple16: rgba($boxPurple, 0.16);\n$boxDarkPurple: #332A4B;\n\n:export {\n  // Theme Colors\n  primary: $primary;\n  secondary: $secondary;\n  yellow: $yellow;\n  red: $red;\n  teal: $teal;\n  orange: $orange;\n  lightGray: $lightGray;\n  whiteSmoke: $whiteSmoke;\n  manatee: $manatee;\n  obsidian: $obsidian;\n\n  // Status Colors\n  success: $success;\n  warning: $warning;\n  error: $error;\n\n  // Other Colors\n  white: $white;\n  black: $black;\n  gray: $gray;\n  darkGray: $darkGray;\n  mediumGray: $mediumGray;\n  lighterGray: $lighterGray;\n  lightSlateGray: $lightSlateGray;\n  carrot: $carrot;\n  lightSmoke: $lightSmoke;\n  graphBlue: $graphBlue;\n  lightOrchid: $lightOrchid;\n  rainboots: $rainboots;\n  royalBlue: $royalBlue;\n  sushi: $sushi;\n\n  // Component Colors\n  primaryButtonBackground: $primaryButtonBackground;\n  primaryButtonText: $primaryButtonText;\n  secondaryButtonBackground: $secondaryButtonBackground;\n  secondaryButtonText: $secondaryButtonText;\n  navigationText: $navigationText;\n  scheduleMusic: $scheduleMusic;\n  scheduleMessageBlock: $scheduleMessageBlock;\n  scheduleInterrupt: $scheduleInterrupt;\n  scheduleLoop: $scheduleLoop;\n  \n  // Variants: Theme Colors\n  primary16: $primary16;\n  primary40: $primary40;\n  primary50: $primary50;\n  primary60: $primary60;\n  secondary25: $secondary25;\n  secondary50: $secondary50;\n  secondary75: $secondary75;\n  yellow16: $yellow16;\n  yellow25: $yellow25;\n  yellow75: $yellow75;\n  orange16: $orange16;\n  orange32: $orange32;\n  orange50: $orange50;\n  orange75: $orange75;\n  manatee16: $manatee16;\n  manatee50: $manatee50;\n\n  // Variants: Status Colors\n  success10: $success10;\n  success16: $success16;\n  success75: $success75;\n  warning50: $warning50;\n  error10: $error10;\n  error16: $error16;\n  error20: $error20;\n  error50: $error50;\n  error75: $error75;\n  error85: $error85;\n\n  // Variants: Other Colors\n  gray50: $gray50;\n  gray200: $gray200;\n  gray300: $gray300;\n  gray400: $gray400;\n  gray500: $gray500;\n  gray700: $gray700;\n  gray900: $gray900;\n  carrot16: $carrot16;\n  rainboots16: $rainboots16;\n  royalBlue16: $royalBlue16;\n  boxPurple16: $boxPurple16;\n\n  // Box colors (for color picker)\n  boxRed: $boxRed;\n  boxPink: $boxPink;\n  boxOrange: $boxOrange;\n  boxYellow: $boxYellow;\n  boxGreen: $boxGreen;\n  boxDarkGreen: $boxDarkGreen;\n  boxBlue: $boxBlue;\n  boxDarkBlue: $boxDarkBlue;\n  boxPurple: $boxPurple;\n  boxDarkPurple: $boxDarkPurple;\n}\n","@use '../../sass/color.scss' as color;\n\n.ManageTags {\n  height: 100%;\n  font-size: 12px;\n  overflow: hidden;\n\n  .manage-header {\n    display: flex;\n    align-items: center;\n    height: 105px;\n    padding: 0 30px;\n\n    .header-info {\n\n      .header-title {\n        display: flex;\n        align-items: center;\n        margin-bottom: 15px;\n        font-size: 18px;\n        font-weight: 900;\n\n        .undo-redo {\n          margin-left: 20px;\n          user-select: none;\n        }\n      }\n\n      .header-subtitle {\n        font-size: 14px;\n      }\n    }\n\n    .header-buttons {\n      flex-grow: 1;\n      display: flex;\n      justify-content: flex-end;\n      gap: 8px;\n    }\n  }\n\n  .manage-tabs {\n    display: flex;\n    height: 30px;\n    padding: 0 30px;\n    user-select: none;\n\n    .tab {\n      cursor: pointer;\n      position: relative;\n      margin-right: 15px;\n      text-transform: uppercase;\n\n      .active-bar {\n        display: none;\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        height: 4px;\n        background: color.$primary;\n      }\n\n      &.active {\n        font-weight: 900;\n\n        .active-bar {\n          display: block;\n        }\n      }\n    }\n  }\n\n  .manage-tag-list-container {\n    // height: calc(100% - 72px - 30px - 105px);\n    height: calc(100% - 207px);\n\n    .tag-loader {\n      position: absolute;\n      top: calc(50% - 37.5px);\n      left: calc(50% - 37.5px);\n      transform: translate(-50%, -50%);\n    }\n\n    .manage-tag-list {\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      justify-content: center;\n      gap: 8px;\n      padding: 0 24px;\n      margin-bottom: 24px;\n    }\n\n    .add-tags-container {\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      margin: 0 auto;\n      width: 300px;\n      height: 105px;\n      padding-top: 20px;\n      padding-bottom: 20px;\n\n      .add-tag-error {\n        position: relative;\n        display: block;\n        margin-top: 16px;\n        line-height: 16px;\n        color: color.$error;\n\n        span {\n          font-weight: bold;\n        }\n      }\n\n      .label-add-tag {\n        display: block;\n        margin-bottom: 5px;\n        font-size: 12px;\n        color: color.$manatee;\n        text-transform: uppercase;\n      }\n\n      .add-tag-input-container {\n        position: relative;\n\n        .input-add-tag {\n          width: 100%;\n          height: 40px;\n          margin: 0 auto;\n          padding-left: 10px;\n          padding-right: 70px;\n          font-size: 18px;\n          box-sizing: border-box;\n          border: 1px solid color.$whiteSmoke;\n          border-radius: 4px;\n\n          &:focus {\n            outline: none;\n            border: 1px solid color.$primary;\n          }\n        }\n\n        .icon-delete-input {\n          position: absolute;\n          top: 0;\n          right: 30px;\n          height: 100%;\n          display: flex;\n          flex-direction: column;\n          justify-content: center;\n          padding: 0 10px;\n        }\n\n        .icon-add-tag {\n          cursor: pointer;\n          position: absolute;\n          top: 0;\n          right: 0;\n          height: 100%;\n          display: flex;\n          flex-direction: column;\n          justify-content: center;\n          padding: 0 12px;\n        }\n      }\n    }\n\n    .empty-tags {\n      margin-top: 20px;\n      font-size: 18px;\n      color: color.$manatee;\n      text-align: center;\n\n      .empty-add-tags {\n        margin-top: 5px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export var primary = `#333F48`;
export var secondary = `#222732`;
export var yellow = `#FECF0C`;
export var red = `#E02D4F`;
export var teal = `#23CCC3`;
export var orange = `#F66733`;
export var lightGray = `#F6F6F6`;
export var whiteSmoke = `#E1E1E9`;
export var manatee = `#959AAD`;
export var obsidian = `#383838`;
export var success = `#00A474`;
export var warning = `#FFC107`;
export var error = `#CF0838`;
export var white = `#FFFFFF`;
export var black = `#000000`;
export var gray = `#757575`;
export var darkGray = `#A4A7B7`;
export var mediumGray = `#E0E0E0`;
export var lighterGray = `#E3E7F4`;
export var lightSlateGray = `#8A8FA3`;
export var carrot = `#FF892E`;
export var lightSmoke = `#F5F4F5`;
export var graphBlue = `#1570EF`;
export var lightOrchid = `#7F56D9`;
export var rainboots = `#3361E1`;
export var royalBlue = `#4085DE`;
export var sushi = `#95C653`;
export var primaryButtonBackground = `#FECF0C`;
export var primaryButtonText = `#333F48`;
export var secondaryButtonBackground = `#333F48`;
export var secondaryButtonText = `#FFFFFF`;
export var navigationText = `#95A3AD`;
export var scheduleMusic = `#FCC7B3`;
export var scheduleMessageBlock = `#23CCC3`;
export var scheduleInterrupt = `#1997A3`;
export var scheduleLoop = `#333F48`;
export var primary16 = `rgba(51, 63, 72, 0.16)`;
export var primary40 = `rgba(51, 63, 72, 0.4)`;
export var primary50 = `rgba(51, 63, 72, 0.5)`;
export var primary60 = `rgba(51, 63, 72, 0.6)`;
export var secondary25 = `rgba(34, 39, 50, 0.25)`;
export var secondary50 = `rgba(34, 39, 50, 0.5)`;
export var secondary75 = `rgba(34, 39, 50, 0.75)`;
export var yellow16 = `rgba(254, 207, 12, 0.16)`;
export var yellow25 = `rgba(254, 207, 12, 0.25)`;
export var yellow75 = `rgba(254, 207, 12, 0.75)`;
export var orange16 = `rgba(246, 103, 51, 0.16)`;
export var orange32 = `rgba(246, 103, 51, 0.32)`;
export var orange50 = `rgba(246, 103, 51, 0.5)`;
export var orange75 = `rgba(246, 103, 51, 0.75)`;
export var manatee16 = `rgba(149, 154, 173, 0.16)`;
export var manatee50 = `rgba(149, 154, 173, 0.5)`;
export var success10 = `rgba(0, 164, 116, 0.08)`;
export var success16 = `rgba(0, 164, 116, 0.16)`;
export var success75 = `rgba(0, 164, 116, 0.75)`;
export var warning50 = `rgba(255, 193, 7, 0.5)`;
export var error10 = `rgba(207, 8, 56, 0.1)`;
export var error16 = `rgba(207, 8, 56, 0.16)`;
export var error20 = `rgba(207, 8, 56, 0.2)`;
export var error50 = `rgba(207, 8, 56, 0.5)`;
export var error75 = `rgba(207, 8, 56, 0.75)`;
export var error85 = `rgba(207, 8, 56, 0.85)`;
export var gray50 = `#F9FAFB`;
export var gray200 = `#EAECF0`;
export var gray300 = `#D0D5DD`;
export var gray400 = `#98A2B3`;
export var gray500 = `#667085`;
export var gray700 = `#344054`;
export var gray900 = `#101828`;
export var carrot16 = `rgba(255, 137, 46, 0.16)`;
export var rainboots16 = `rgba(51, 97, 225, 0.16)`;
export var royalBlue16 = `rgba(64, 133, 222, 0.16)`;
export var boxPurple16 = `rgba(109, 109, 181, 0.16)`;
export var boxRed = `#E02D4F`;
export var boxPink = `#F57A7A`;
export var boxOrange = `#F66733`;
export var boxYellow = `#FECF0C`;
export var boxGreen = `#95C653`;
export var boxDarkGreen = `#00A474`;
export var boxBlue = `#33ACE1`;
export var boxDarkBlue = `#3361E1`;
export var boxPurple = `#6D6DB5`;
export var boxDarkPurple = `#332A4B`;
export default ___CSS_LOADER_EXPORT___;
